var pg;

//require("firebase/firestore")
import firebase from '@firebase/app'

import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
//import "firebase/analytics";

import currency from "currency.js";



import yall from 'yall-js'




const hexRgb = require('hex-rgb');

//import videojs from 'video.js'

import axios from 'axios';

import {
    loadStripe
} from '@stripe/stripe-js/pure';




export const store = {

    website : "a",
    siteName : "Giftycard",

    //slideShowStarted : false,

    loading : false, //universal boolean to throw activity spinners when user is performing a async job

    //grab the configuration for this database
    firebaseConfig: {

        apiKey: "AIzaSyCWtexZQ-cJxEcvCH6Uwwa3bMkhi5Tv8uM",
        authDomain: "auth.picpack.app",
        projectId: "kindlymail-3bb52",
        storageBucket: "kindlymail-3bb52.appspot.com",
        messagingSenderId: "704096795217",
        appId: "1:704096795217:web:198f7a001692172a671670",
        measurementId: "G-L7NR3S05TV"


    },

    //robot
    //wedding
    //cake
    //cupcakes
    //mural
    //people
    //spacebar
    //hand raise

    wallpaperImages : ['1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg','24.jpg','15.jpg','a80s-trunks.jpg','acer.jpg','acorn.jpg','afx-skyrim.jpg','afx-snowflake.jpg','aidan.jpg','alexandria.jpg','aloha-turkey.jpg','anchors.jpg','angry-argyle.jpg','animus-mix.jpg','antionette.jpg','armada.jpg','armored.jpg','arrowheads.jpg','aureate.jpg','autumn-butterflies.jpg','avalon.jpg','bamboo.jpg','banana.jpg','bandwidth.jpg','baron.jpg','battle-royale.jpg','beachy-lines.jpg','beachy.jpg','berry-swirl.jpg','bewitched.jpg','bit-tile-blue.jpg','blue-lotus.jpg','blue-rings.jpg','blue-stripe.jpg','blue-striped-circles.jpg','blue.jpg','blueprint.jpg','bones-leather.jpg','breeze.jpg','broach.jpg','brooks.jpg','burnt-tropics.jpg','cabin.jpg','camellia.jpg','carver.jpg','cellar-heat.jpg','charcoal.jpg','chess-dark.jpg','chocolate-diamond.jpg','clydes-tie.jpg','coaster.jpg','cold-war-lions.jpg','counsel.jpg','cranberry.jpg','curly.jpg','dark-canvas.jpg','dark-forest.jpg','dark-square.jpg','dark-tile.jpg','dead-kings.jpg','denim-daisies.jpg','devilish.jpg','dharma-initiative-blue.jpg','dharma-initiative-jungle.jpg','dharma-initiative.jpg','dinpattern-stripe.jpg','dinvolver.jpg','dirty-vintage.jpg','disco-blue.jpg','disco-gold.jpg','discs.jpg','distressed-in-blue.jpg','drunken-royal.jpg','easy-purple.jpg','easy-tile.jpg','echeveria.jpg','eerie.jpg','elder.jpg','elephant.jpg','elixir.jpg','emerald.jpg','falcon.jpg','fallLeaves.jpg','fault.jpg','finding-a-cure.jpg','flower-burst.jpg','foss-inspired.jpg','found.jpg','foundation.jpg','franklin.jpg','frisky.jpg','fronds.jpg','frost-variant.jpg','frost.jpg','frozen.jpg','fruit-salad.jpg','fuchsia.jpg','gatsby.jpg','gazing-girl.jpg','german-pinks.jpg','gervan.jpg','ghost-tile.jpg','giza.jpg','golden-dragons.jpg','golden-victorian.jpg','grandmas-sofa.jpg','grandpa-jims-favorite-suit.jpg','green-deco.jpg','green-hawaii.jpg','green-monsters.jpg','greenhorn.jpg','gridded-blue.jpg','grunge-green.jpg','gunpowder-tea.jpg','gunpowder-velvet.jpg','harper.jpg','haunted-red.jpg','haunted-two-regal.jpg','haunted-two.jpg','haunted.jpg','hearts-and-lives.jpg','hearts.jpg','heritage.jpg','hold-fast.jpg','hollyhock.jpg','horse-shoe-cover.jpg','horton.jpg','hot-pink-damask.jpg','humidor-pink.jpg','humidor.jpg','huskey-pete.jpg','indian-summer.jpg','intertwined-darkened.jpg','intertwined.jpg','intrigue.jpg','invaders.jpg','iridescent.jpg','irish.jpg','iron-gate.jpg','israel.jpg','its-bright-outside.jpg','judah-helix.jpg','karachi.jpg','khaki.jpg','kitchen-walls-blue.jpg','larkspur-two.jpg','larkspur.jpg','lava-rock.jpg','leather-walls.jpg','lennox.jpg','light-tile.jpg','limeade.jpg','lotus-vases.jpg','luke-aztec.jpg','lunar-light.jpg','lunar-midnight.jpg','luxury-lining.jpg','madrona.jpg','medallion-burned.jpg','medallion-tightened-blue.jpg','medallion-webbed.jpg','medusa-chandelier.jpg','modern-warfare-3.jpg','museum-walls.jpg','navy-diamond.jpg','nori.jpg','northern-lights.jpg','octo-redux.jpg','OHNO.jpg','old-31.jpg','old-posy-gold.jpg','old-vine.jpg','once-cool-linoleum.jpg','overly-rosie.jpg','palmetto-desaturated.jpg','palmetto-merlot-lines.jpg','palmetto.jpg','palms.jpg','panda-madness.jpg','paper-flower.jpg','paragon.jpg','parker.jpg','peach-swirl.jpg','peacock-blue-experimental.jpg','picnic.jpg','pink-cheetah.jpg','pink-lines.jpg','pink.jpg','pinkie-bouquet.jpg','pinkie.jpg','pixel-floral-blue.jpg','pixel-gray.jpg','plum-pinwheel.jpg','plum-thatch.jpg','plum.jpg','pomegranate.jpg','prestige-COD.jpg','prestige-one.jpg','prestige.jpg','prim-walls.jpg','pumpkin-peak.jpg','pumpkin.jpg','purple-pyramid.jpg','purple-spiral.jpg','pyramid.jpg','queen-lime-carpet-sample.jpg','queens-quilt.jpg','quick-brick.jpg','rafters.jpg','rather-orange-blossom.jpg','ravens.jpg','red-hallway-runners.jpg','red-tiger.jpg','regal.jpg','relic-jungle.jpg','relic-purple-lines.jpg','relic-xmas-paper.jpg','relic.jpg','renzler-power-down.jpg','renzler.jpg','retro-leaves.jpg','ribbon.jpg','ridge.jpg','ripple.jpg','risen.jpg','royal-gate.jpg','royal-lobsterific.jpg','royal-pajamas.jpg','royal-red.jpg','royals.jpg','ruby-soft.jpg','ruby-sundial.jpg','ruby.jpg','rust.jpg','sakura.jpg','salem.jpg','salvage.jpg','sand-blossom.jpg','sanskrit.jpg','sapphire.jpg','scripts.jpg','sea-scope.jpg','seananners-woodcut.jpg','shanghai.jpg','shortened-evening.jpg','simple-checker.jpg','simple-paisley.jpg','skippy.jpg','soft-grid.jpg','some-strong-coffee.jpg','something-70s-bright.jpg','something-70s-subtle.jpg','spain.jpg','spongie.jpg','stand-in.jpg','starliner.jpg','steadfast-red.jpg','steadfast.jpg','steel.jpg','straw-flowers.jpg','structure.jpg','subliminal.jpg','subtle-wood.jpg','sunrise.jpg','sweeper.jpg','tangerine.jpg','tea-leaves.jpg','techno.jpg','ten-thousand-things.jpg','thatch.jpg','threaded-dark-one.jpg','threaded-purple.jpg','tina.jpg','titian.jpg','transmit.jpg','tread.jpg','tropical-headache.jpg','tutorial.jpg','twirl-II.jpg','twirl.jpg','ultra-violet.jpg','urban-royalty.jpg','vachetta.jpg','valves.jpg','veerle.jpg','victorian-sunshine-border.jpg','vintage-pinstripe.jpg','vintage-red.jpg','vintage-scarlet.jpg','violet-fabric.jpg','violet.jpg','vivid-grunge.jpg','waves.jpg','winchester-walls.jpg','worn-discs.jpg','woven.jpg','y-so-serious-white.png','watercolor.png','repeated-square.png','pixel-heart.png','oriental-tiles.png','moroccan-flower.png','geometric-leaves.png','double-bubble.png','_s_a12Cb12Cc12Cd12Ce0f0g64hECF1D81DFED5FFFD61FF3D00020925222227iCj0k45l166m166.jpg','white-wood.jpg','subway-lines.png','subway-lines.png','special-delivery.jpg','naranjas.png','kiwis.png','fiesta.jpg','cuadros.png','science.png','magnus-2051.png','bunting-flag.png','bicycles.png','asteroids.jpg'],

    leftoverHeight : 0, //determines the height we have to work with
    portraitOrientation : true, //determine what the orientation of window is
    live : false, //determine if we are on the live page
    pauseLive : false,
    mediaIndex : -1,
    slideShowStarted : false,

    typeOfLogin : "", //tells us if we are logging in or signing up

    picpackCodeLength : 6,

  

    uploadedImageArray : [],


    addGift : false,
    addMessage : false,
    giftDenomination : 0,
    customDenomination : false,
    processingFeeCharge : 0,
    giftMessage : "",
    giftMessageSaved : false,
    purchasing : false,
    purchased : false,
    noteFontName : "family1",
    noteColor : '#FDE388',
    noteColorIndex : 0,
    colorArray : ['#FDE388','#E5E5E9','#FBCCE4','#C7CFFA','#BFD8FA','#A6F0CD','#FEC7C7'],
    giftycardID : '', //pulled from URL that is mailed to giftycard recipient
    cardState : "invalid",
    giftTip : "mediumTip",
    finalGiftDenomination : 0,
    lowTip : 1,
    mediumTip : 2,
    highTip : 3,
    giftLink : "",
    teamNameValid : true,
    recipientNameValid : true,
    recipientEmailValid : true,
    

    addGif : false,
    gifSearchQuery : "",
    gifs : [],
    gifsLoading : false,
    savingGif : false,
    savingNote : false,

    teamName : "",
    recipientEmail : "",
    recipientName : "",
    statusMessage : "",
    
    
    wallpaperImages2 : ['1.jpg','2.jpg','3.jpg','4.jpg','5.jpg','6.jpg','7.jpg','8.jpg','9.jpg','10.jpg','11.jpg','12.jpg','13.jpg','24.jpg','15.jpg'],

    successSnippets : ['High Five!','Hooray!','Cheers!','Booyah!','Bravo!','Thumbs up!','Kudos!'],
    successSnippet : '',

    successConfirmations : ['Your upload is being processed and will be out the door soon. ','Your upload has been received and will be ready soon. ','Your upload is being processed and will be available soon. ','Your upload is quickly processing and will be ready soon. ','Your upload is being optimized and will be ready very soon. ','Your upload has been received and will be ready soon. '],
    successConfirmation : "",

    dropdownOn: false,

    mediaCount: 50, //used to define how many document we grab per lookup

    demoURL: '/welcome-to-picpack',

    galleryOpened: false, //know when we should append images to gallery

    moreDocs: true, //tells us if we need to go get more documents from firestore on infinite scroll
    pauseScrollDetection: false, //turns on scroll detection if we are grabbing docs.  don't need to keep grabbing

    cookieSet: false, //flag so we don't keep setting the cookie on infinite scroll

    downloadDetails : "",

    videoUploaded : false,

    //displayFilter : '', //used to let manager choose what to show on managagement page

    lastApprovedDocID: '',
    lastNotApprovedDocID: '',

    manageEvent: true, //a little logic to determine if we are on event or manage page to discern if we should show approved / not approved

    numberOfPurchasedImages: 3, //number of optional images user can purchase
    numberOfPurchasedImagesArray: [100, 250, 500, 1000, 5000],
    priceArray: [5, 10, 15, 25, 50],

    numberOfPurchased2Images: 2, //number of optional images user can purchase
    numberOfPurchased2ImagesArray: [500, 2500, 5000, 10000, 20000],
    numberOfEvents2Array: [3, 10, 25, 50, 75],
    priceArray2: [15, 30, 45, 60, 75],

    numberOfEnterpriseImages: 50000,

    numberOfFreeImages: 25,

    freshMediaCollectionArray: [], //when we get new images, we stuff all of the images in here so we can refresh when user wants to

    newImageCount: 0, //tracks new images from a snapshot

    showEntirePage: false, //used to blank a page entirely on logout

    logging: false, //show logs to troubleshoot on mobile

    showFooter: false, //used to not show footer until content loads asyc
    showMedia : true,

    localhost: false,
    authEstablished: false, //indicates if we have attempted authentication yet
    authToken: '', //stores the users auth token from firebase
    isAuthenticated: false, //indicated whether user is authenticated with firebase
    userID: '', //indicates the users id if authenticated
    name: '', //indicates the users display name if auth
    email: '', //indicates the users email name if auth
    phoneNumber: '', //indicates the users phone number if auth
    emailVerified : false,
    existingCustomer: false, //used to tell us if we need to create a new stripe customer via API.  
    authorizationType: "", //need to create customers in stripe with either phone or email


     //-------------------------------------------------------------------------------
    //create a blob - not my code so not touching it 
    //-------------------------------------------------------------------------------
    dataURItoBlob: function(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        var ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        var blob = new Blob([ab], {
            type: mimeString
        });
        return blob;

    },

     //---------------------------------------------------------------------------------------
    //highlight something for a split second.  used when saving things or copying to clipboard
    //-------------------------------------------------------------------------------------
    highlightElement: function(fieldID) {


        document.getElementById(fieldID).classList.add('highlight')
        setTimeout(() => {
            document.getElementById(fieldID).classList.remove('highlight')
        }, 1100);


    },
    //-------------------------------------------------------------------------------


    //-------------------------------------------------------------------------------
    //copy qr codes to the users clipboard 
    //-------------------------------------------------------------------------------
    copyImageToClipboard: function(imageID, highlightElementID) {

        //show the user visually that they have copied something
        store.highlightElement(highlightElementID)

        console.log(imageID)

        //blob the image
        var image = document.getElementById(imageID)

        console.log(image.src)

        var imageBlob = store.dataURItoBlob(image.src)

        
        //copy the image to the users clipboard
        try {
            navigator.clipboard.write([
                new ClipboardItem({
                    'image/png': imageBlob
                })
            ])


        } catch (error) {
            console.error(error);
        }



    },
    //-----------------------------------------------------------------------------------


   

    stripeID: '',
    credits: 0,
    plan: "",
    planSelected: false,
    planSelectedIndex: 0,
    planDescriptionArray: ['Free', 'One Time PicPack', 'Event Planner', 'Enterprise'],

    planDescriptionSubArray: [
        [{
                i: 100,
                e: 1,
                a: 5,
                p: ['price_1IG6QlFE54E661IRty4ZxrLb', 'price_1IG6a4FE54E661IRyo2yxzh7']
            },
            {
                i: 250,
                e: 1,
                a: 10,
                p: ['price_1IG6RZFE54E661IR2iHO4Ejx', 'price_1IG6ZzFE54E661IRgdEZ6PUA']
            },
            {
                i: 500,
                e: 1,
                a: 15,
                p: ['price_1IG6S8FE54E661IRVPcGacjy', 'price_1IG6ZuFE54E661IRiqcpZHEH']
            },
            {
                i: 1000,
                e: 1,
                a: 25,
                p: ['price_1IG6SjFE54E661IRJs4t0Wou', 'price_1IG6ZqFE54E661IRYAimYq5M']
            },
            {
                i: 5000,
                e: 1,
                a: 50,
                p: ['price_1IG6TIFE54E661IRpa3TUrP9', 'price_1IG6ZlFE54E661IRTJt4Hyq8']
            }
        ],

        [{
                i: 500,
                e: 3,
                a: 15,
                p: ['price_1IG6UBFE54E661IRU6HQN0bl', 'price_1IG6ZhFE54E661IRLMJ7SPOe']
            },
            {
                i: 2500,
                e: 10,
                a: 30,
                p: ['price_1IG6VkFE54E661IRUDrY5YiH', 'price_1IG6ZcFE54E661IRKlApSD6e']
            },
            {
                i: 5000,
                e: 25,
                a: 45,
                p: ['price_1IG6WOFE54E661IRtlgzNid4', 'price_1IG6ZXFE54E661IRKtnfjHFB']
            },
            {
                i: 10000,
                e: 50,
                a: 60,
                p: ['price_1IG6X1FE54E661IREZtyKuAm', 'price_1IG6ZSFE54E661IRVmIeX53j']
            },
            {
                i: 20000,
                e: 75,
                a: 75,
                p: ['price_1IG6XgFE54E661IRI4FchIix', 'price_1IG6ZKFE54E661IRVlQbK06D']
            }
        ]
    ],

    enterprisePlan: ['price_1IC9SaFE54E661IRdtIa3fKs', 'price_1IG6a9FE54E661IRfs6g03k7'],
    enterpriseImages : 100000,
    enterpriseCredits: 100,

    planDescription: "",
    planImages: 0,
    planEvents: 0,

    planAmountStringArray: ['Free', '$5/one time', '$20/month', '$100/month'],
    planAmountArray: [0, 5, 20, 100],
    planAmount: 0,
    planAmountString: "",

    portalLoading: false, //used to drive the portal logic
    portalLink: "",

    storageBucketRootURL: "https://media.picpack.app/",
    assetsBucketRootURL: "https://assets.picpack.app/",

    devFunctionsEndpoint: "http://localhost:5001/kindlymail-3bb52/us-central1/",
    prodFunctionsEndpoint: "https://us-central1-kindlymail-3bb52.cloudfunctions.net/",
    functionEndpoint: "",



    imageArray: [],

    uploadedFiles: [], //keeps list of files user has uploaded to be displayed on page.....

    maxVideoDuration: 60,
    secretFolder: "", //where we keep stuff

    requireApproval: true, //does this event require someone to approve images and videos


    photoIndex: 0,

    uploadFileCount: 0, //keeps track of number of files uploaded so we know when we are done
    uploadedFileCount: 0,
    //processedFilesCount : 0,

    initialSnapshot: true, //make sure we ignore the first time a snapshot fires. 

    //finalUploadedFiles: [],

    eventDoc: [], //stores the event doc we lookup

    notApprovedImages: [],
    approvedImages: [],
    tempApprovedImages: [], //temp store to push into and sort when we are done to then present
    tempNotApprovedImages: [], //temp store to push into and sort when we are done to then present

    logMessage: "Start",

    eventDetailsLoaded: false,

    eventName: "", //display the name of the event on the events and management page
    eventDescription : "",
    requirePassword: false,
    requireCaption : false,
    requireEmail : false,
    emailAddress : "",
    emailSet : false,
    badEmail : false,
    passwordBad: true,

    eventImageURL: "",
    backgroundColor: "#90CAF9",

    checkingPassword: false,

    fontIndex : 0,
    fontName : 'family1',
    fontCount : 14,

    //used to test security
    async listFiles() {
        // Lists files in the bucket
        const [files] = await storage.bucket(bucketName).getFiles();

        console.log('Files:');
        files.forEach(file => {
            console.log(file.name);
        });
    },




    loadGifSelector : function() {



        store.gifSearchQuery = ""

        store.addMessage = false
        store.addGift = false
        store.addGif = true
        store.showMedia = false
        store.purchased = false

        store.uploadedFiles = []
        store.uploadFileCount = 0
        
       


        $('#gifSearch').keyup(store.delay(function (e) {
            store.searchGIFs()
          }, 1000));



    },



    selectGif : function(gif) {

        store.gifs.forEach(function (gif) {
           gif.is_hidden = false
          });

        console.log(gif)


        gif.is_hidden = true


    },


    saveGif : function(gif) {

        store.savingGif = true



        store.firestore.collection('events').doc(store.vue.eventID).get().then(eventDoc => {



            //this is stupid.  why do I have to grab a reference when I already have the doc above?
            eventDoc.ref.collection('media').doc(encodeURIComponent(gif.images.original.url)).set({

               "m": "image/giphy",
               "w": gif.images.original.width,
               "d": "0",
               "h": gif.images.original.height,
               "a": true,
               "t": Date.now(),
               //"c": "",
               "e" : "",
               "c": ""
               


           }).then(note => {


            store.gifSearchQuery = ""


            store.addGif = false
       store.gifs = []
       

       store.approvedImages.unshift({'mediaType':'image/giphy','email':'','imageApproved':true,'width':gif.images.original.width,'height':gif.images.original.height,'imageCaption':'','imageName':encodeURIComponent(gif.images.original.url)})

        yall({

            observeChanges: true,
            callback: "log"

        });

        store.showMedia = true
        window.scrollTo(0, 0);
        store.savingGif = false

        confetti.start(500);


       store.vue.$forceUpdate();


        gif.is_hidden = true

              


           }).catch(noteError => {

               console.log(noteError)


           })


       }).catch(eventError => {

           console.log(eventError)

       })





       


    },


    searchGIFs: async function() {

        store.gifs = []
        store.gifsLoading = true

       // $('.grid').masonry('destroy')


        console.log(store.gifSearchQuery)

        //const { data: gifs } = await store.gf.search(store.gifSearchQuery, { sort: 'relevant', lang: 'en', limit: 50 })

        console.log(gifs)

        

       // renderGrid({ width: 800, gifs }, )

       

       
      



        store.gifs = gifs
        store.gifsLoading = false

        store.vue.$forceUpdate();

        /*

        setTimeout(function(){ 


            store.masonry = $('.grid').masonry({
                itemSelector: '.grid-item',
                percentPosition: true,
                columnWidth: '.grid-sizer',
                gutter: 10
                });
    
    
                


                  store.masonry.imagesLoaded()
                 
                  .progress( function( instance, image ) {
                    store.masonry.masonry();
                    setTimeout(function(){ if ( store.gifsLoading !== false ) {store.gifsLoading = false }},250)
                    //var result = image.isLoaded ? 'loaded' : 'broken';
                    //console.log( 'image is ' + result + ' for ' + image.img.src );
                  });
    
            
               






        }, 500);

        */


    },



    delay : function(callback, ms) {
        var timer = 0;
        return function() {
          var context = this, args = arguments;
          clearTimeout(timer);
          timer = setTimeout(function () {
            callback.apply(context, args);
          }, ms || 0);
        };
      },




    initiateGiftycard : function(event) {


        console.log('send gifty card')
        event.sendingGiftycard = true



    },




    redeemCard : async function() {

        store.loading = true


       


        


        axios.post(store.functionEndpoint + "redeemCard", {

            giftycardID : store.giftycardID,
            legalName : store.legalName,
            address : store.address,
            city : store.city,
            state : store.state,
            zipcode : store.zipcode,



        }).then(response => {

            console.log(response)
            store.loading = false



        }).catch(error => {

            store.loading = false
            console.log(error)

        })





    },


    getGiftycard : function(event) {

        let giftycardRef = store.firestore.collection('giftycard').doc(event.eventID)
        let giftycardDoc = giftycardRef.get().then(giftDoc => {
                                    
            
            if (!giftDoc.exists) {

                console.log('cant find the giftycard')



            } else {

                console.log(giftDoc.data().giftLink)
                event.giftycardLink = giftDoc.data().giftLink
                event.recipientName = giftDoc.data().recipientName
                event.teamName = giftDoc.data().teamName



            }


        }).catch(error => {

            console.log('bad happening with giftycard')


        })





    },


    sendGiftycard : function(event) {

       

        var giftycardFormValid = true

        if ( store.teamName === '' ) {

            giftycardFormValid = false
            store.teamNameValid = false

        } else {

            store.teamNameValid = true

        }

        if ( store.recipientName === '' ) {

            giftycardFormValid = false
            store.recipientNameValid = false

        } else {

            store.recipientNameValid = true


        }


        if ( store.validateEmail(store.recipientEmail) ) {

            console.log('valid email')
            store.recipientEmailValid = true


        } else {

            giftycardFormValid = false
            store.recipientEmailValid = false


        }



        if (  giftycardFormValid ) {

            event.processingGiftycard = true


                    axios.post(store.functionEndpoint + "sendGiftycard", {

                        //used to determine if this is the user who created the picpack
                        teamName : store.teamName,

                        recipientEmail: store.recipientEmail,
                        recipientName: store.recipientName, //how many documents do we grab we each pagination

                        //giftDenomination : giftDenomination,
                        //processingFee : processingFee,
                        
                        eventID : event.eventID,
                        eventQuickcode : event.eventDetail.quickcode,
                        userID : store.userID,

                        localhost: store.localhost
                        

                    }).then(response => {

                        console.log(response)
                        if ( response.data.success ) {

                            event.attemptedGiftycardSend = true
                            event.sentGiftycard = true
                            event.giftGiven = true
                            confetti.start(500)
                            
                           

                            store.getGiftycard(event)




                        } else {

                            console.log('something went way wrong')
                            event.attemptedGiftycardSend = true
                            event.sentGiftycard = false


                        }



                    }).catch(error => {

                        console.log(error)


                    })


        }


    },




    saveNote : function() {

        store.savingNote = true

        if ( store.giftMessage.length > 0 ) {


        console.log('okokok')
       // store.firestore.collection('events').doc(store.vue.eventID).get().then(eventDoc => {



             //this is stupid.  why do I have to grab a reference when I already have the doc above?
             store.firestore.collection('events').doc(store.vue.eventID).collection('media').add({
             //eventDoc.ref.collection('media').doc().set({

                "m": "note",
                //"w": "",
                //"d": "",
                //"h": "",
                "a": true,
                "t": Date.now(),
                //"c": "",
                //"e" : "",
                "c": store.giftMessage.replace(/\n/g, "\\n"),
                "f": store.noteFontName,
                "l": store.noteColor,


            }).then(note => {

                console.log(note.id)

                //store.giftMessageSaved = true
                store.addMessage = false
                store.addGift = false
                store.addGif = false
                store.showMedia = true
                store.purchased = false

                confetti.start(500);

                store.approvedImages.unshift({'imageName': note.id,email:'','imageApproved':true,'mediaType':'note','font':store.noteFontName,'color':store.noteColor,'imageCaption':store.giftMessage.replace(/\n/g, "\\n")})

                store.savingNote = false

                


            }).catch(noteError => {

                console.log(noteError)


            })


       // }).catch(eventError => {

          //  console.log(eventError)

       // })

    }



    },




    establishEnvironment : function() {



        store.localhost = location.hostname === 'localhost' || location.hostname.includes("192.") ? true : false
       
        store.functionEndpoint = location.hostname === 'localhost' ? store.devFunctionsEndpoint : store.prodFunctionsEndpoint

        if ( store.localhost ) {

            if ( location.port === '8081' ) {

                store.website = "b"
                store.siteName = "Giftycard"
                store.demoURL = "/teacher-appreciation"
                store.storageBucketRootURL =  "https://media.giftycard.app/"
                store.assetsBucketRootURL = "https://assets.giftycard.app/"
                


            } else {

                store.website = "a"
                  store.siteName = "PicPack"

            }

            console.log(location)


        } else {

             if ( location.hostname === 'giftycard.app' ) {

                store.website = "b"
                store.siteName = "Giftycard"
                store.demoURL = "/teacher-appreciation"
                store.storageBucketRootURL =  "https://media.giftycard.app/"
                store.assetsBucketRootURL = "https://assets.giftycard.app/"


            } else {

                store.website = "a"
                 store.siteName = "PicPack"

            }


        }









    },





    login : function() {

        store.vue.signingup = true

    
        console.log('login')

        console.log(store.vue.email)
        console.log(store.vue.password)
    

    store.firebase.auth().signInWithEmailAndPassword(store.vue.email, store.vue.password).then((loginResult) => {

        console.log(loginResult)

        if ( store.website === "a") {

            window.location.replace("/picpacks");


        } else {

            window.location.replace("/giftycards");


        }

        


    }).catch(function(error) {

        store.vue.signingup = false
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        store.vue.badEmail = true
        store.vue.badEmailMessage = "Username / Password is incorrect"

        console.log(errorCode + " : " + errorMessage)
    // ...
    });



},



setNoteColor : function() {


    console.log('we are here')


   

    if ( store.noteColorIndex >= store.colorArray.length - 1 ) {


        store.noteColorIndex = 0


    } else {

        store.noteColorIndex++;


    }

    $('#noteBox').css('background-color',store.colorArray[store.noteColorIndex])
    store.noteColor = store.colorArray[store.noteColorIndex]

     









},





setNoteFont : function() {


    console.log('we are here')


    $('#noteBox').removeClass('family' + store.fontIndex)

    if ( store.fontIndex > store.fontCount ) {


        store.fontIndex = 1


    } else {

        store.fontIndex++;


    }

     $('#noteBox').addClass('family' + store.fontIndex)

     store.noteFontName = 'family' + store.fontIndex









},


    


    setFont : function() {


        console.log('we are here')


            $('#eventDisplayName').removeClass('family' + store.fontIndex)

            if ( store.fontIndex > store.fontCount ) {


                store.fontIndex = 1


            } else {

                store.fontIndex++;


            }

             $('#eventDisplayName').addClass('family' + store.fontIndex)

             store.fontName = 'family' + store.fontIndex







    },



    generateRandomSuccessMessage : function() {

        store.successSnippet = store.successSnippets[Math.floor(Math.random() * store.successSnippets.length)];
        store.successConfirmation = store.successConfirmations[Math.floor(Math.random() * store.successConfirmations.length)];




    },
    



    rgb: function(color) {


        return hexRgb(color)


    },



    shuffle : function(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;
      
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
      
          // Pick a remaining element...
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
      
          // And swap it with the current element.
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
      
        return array;
      },





    //-------------------------------------------------
    //handle our scrolling logic
    //-------------------------------------------------
    enableInfiniteScroll: function() {



        //listen for scroll events
        $(window).scroll(function() {


            //if we are near the bottom
            if ($(window).scrollTop() + $(window).height() + 300 >= $(document).height()) {

                //if we are paused
                if (store.pauseScrollDetection === true) {

                    console.log('----- scroll ------')

                    //console.log("SCROLLED TO BOTTOM!!!!");

                    if (store.moreDocs) {

                        store.pauseScrollDetection = false
                        console.log("Grab more docs");
                        store.lookupEvent()

                    } else {

                        //console.log("No more docs");

                    }

                } else {

                    console.log('just scrolling...... no detection')

                }

            }

        });




    },




    selectFreePlan: function() {

        //window.location.hash = 'free';

        history.pushState({
            planSelected: true,
            plan: 1
        }, '', 'createPicpack/#/free');

        store.planSelected = true
        store.plan = 1
        window.scrollTo(0, 0);



    },



    scrollToTop : function() {


        window.scrollTo(0, 0);


    },



    selectPaidPlan: function(planIndex) {


        history.pushState({
            planSelected: true,
            plan: planIndex
        }, '', 'createPicpack/#/paid');


        //This is fun!!!!

        //grab the selected index of the plan
        store.planSelectedIndex = planIndex
        store.planSelected = true

        //if this is the one time event or event planner package, we have to deal with different packages
        if (planIndex === 2 || planIndex === 3) {

            var packageIndex

            if (planIndex === 2) {

                console.log('SELECTED PLAN:  ONE TIME EVENT')
                packageIndex = store.numberOfPurchasedImages

            }

            if (planIndex === 3) {

                console.log('SELECTED PLAN:  EVENT PLANNER')
                packageIndex = store.numberOfPurchased2Images

            }

           

            //go get the description and then the number of images / events allowed and the price
            store.planDescription = store.planDescriptionArray[planIndex - 1]
            store.planImages = store.planDescriptionSubArray[planIndex - 2][packageIndex].i
            store.planEvents = store.planDescriptionSubArray[planIndex - 2][packageIndex].e
            store.planAmount = store.planDescriptionSubArray[planIndex - 2][packageIndex].a

            

            //if we are localhost we are testing, so grab the dev stripe plan ID
            if (store.localhost) {

                store.selectedPlan = store.planDescriptionSubArray[planIndex - 2][packageIndex].p[0]
                

            //if we are in prod, grab the prod stripe plan
            } else {

                store.selectedPlan = store.planDescriptionSubArray[planIndex - 2][packageIndex].p[1]


            }



        } else {

            console.log('SELECTED PLAN:  ENTERPRISE')

            store.planDescription = store.planDescriptionArray[planIndex - 1]
            store.planAmount = store.planAmountArray[planIndex - 1]
            store.planImages = store.enterpriseImages
            store.planEvents = store.enterpriseCredits

            if (planIndex === 4) {

                if (store.localhost) {

                    store.selectedPlan = store.enterprisePlan[0]


                } else {

                    store.selectedPlan = store.enterprisePlan[1]



                }


            }



            //this is free
        }



        //store.planAmountString = store.planAmountStringArray[planIndex - 1]

        window.scrollTo(0, 0)
        store.initiateStripe()




    },



    enterEvent: function(payload) {

       

        console.log('password good')
        console.log(payload)
        console.log('Secret Folder: ' + payload.secretFolder)

        store.passwordBad = false
        store.checkingPassword = false

        //the cloud function will return our secretr folder which
        //the user will only get from a correct password
        store.secretFolder = payload.secretFolder

         
        //set the users cookie based on the secret folder
        store.setCookie('Cloud-CDN-Cookie', payload.storageCookie)

        //go build out all of the images now
        store.buildupMediaItems(payload.media, false)

        //stick that bar to the top.
        store.makeActionBarSticky()

        

       

    },



    noPlay : function(event) {

        //event.stopPropagation();
        event.preventDefault()

        return false


    },




    refreshMedia: function(event) {

        window.scrollTo(0, 0);


        event.preventDefault()
        event.stopPropagation()

        store.uploadedFiles = []
        store.uploadedFileCount = 0
        store.uploadFileCount = 0
        //store.finalUploadedFiles = []


        store.buildupMediaItems(store.freshMediaCollectionArray, true)
        store.newImageCount = 0
        store.freshMediaCollectionArray = []



    },




    submitPassword : function() {

        store.checkingPassword = true
        store.lookupEvent()



    },




    //-------------------------------------------------

    //-------------------------------------------------
    lookupEvent: function() {

        //pause detecting scrolling while we go grab this stuff
        //store.pauseScrollDetection = true
        
       


        //grab the event, determine if it is password protected and if not
        //lets just do the processing right here and now
        //POST is important so it doesn't show up in server logs
        axios.post(store.functionEndpoint + "lookupEvent", {

            //used to determine if this is the user who created the picpack
            userID : store.userID,

            eventID: store.vue.eventID,
            mediaCount: store.mediaCount, //how many documents do we grab we each pagination

            //tells us if we are grabbing approved / not approved content
            displayFilter: store.vue.displayFilter,

            //depending on the query we run, we need to find the correct pointer
            lastDocID: store.vue.displayFilter === 'approved' ? store.lastApprovedDocID : store.lastNotApprovedDocID,

            //send through password if user supplied
            password: store.vue.userSuppliedEventPassword,

            manageEvent : store.manageEvent 
            

        }).then(function(response) {

            console.log('Response from lookupEvent')
            console.log(response.data)

            if ( response.data.found === false ) {

                window.location = "/404"


            } 

            if ( response.data.requirePassword ) {
           

                //if the password is not blank, this means the user tried to initiate a password respone
                if ( store.vue.userSuppliedEventPassword !== "" ) {


                //if the server said the password is good, lets enter the event
                if (response.data.isPasswordGood) {
    
    
                    store.enterEvent(response.data)
    
    
                //if the password is not good, then well......
                } else {
    
                    console.log('password bad')
                    store.checkingPassword = false
    
                    store.vue.userSuppliedEventPassword = ''
    
                    if ( $('#password').is(":visible")) {

                        console.log('here')
                         document.getElementById("password").placeholder = "Are you sure?" 
                    }

                    store.checkingPassword = false
                    return false
    
                } //end of password good or not check


            } //if password is not blank


            } //end of if we need to check for password

            //tells us if there are still docs remaining
            store.moreDocs = response.data.moreDocs

            //if we just grabbed approved docs, set the last document ID
            if (store.vue.displayFilter === 'approved') {

               store.lastApprovedDocID = response.data.lastDocID

            //if we just grabbed not approved docs, set the last not approved document ID
            } else {

                store.lastNotApprovedDocID = response.data.lastDocID

            }


            //go and build up the event page with the details
            store.buildupEventPage(response.data)

           

            if (response.data.requirePassword === false) {

                //this ensures on the live page we show the start slideshow button
                store.passwordBad = false

                if (store.cookieSet === false) {

                    console.log('setting cookie')
                    console.log(response.data.storageCookie)

                    store.setCookie('Cloud-CDN-Cookie', response.data.storageCookie)
                    store.cookieSet = true

                }


                
                //--------------------------------------------------
                //build out all the good stuff, images / videos!
                //--------------------------------------------------
                console.log('##################################################################')

                store.buildupMediaItems(response.data.media, false)
                store.loading = false



            //if we are requiring a password......
            } else {

               
                //if this is the live page, we can just show all of it
                if ( !store.live) {

                    console.log('not live so show entire page')
                   store.showEntirePage = true
                    store.loading = false

                } else {

                    console.log('live page so we cant show everything until the user clicks slideshow')
                }

            }


            store.pauseScrollDetection = true

        }).catch(error => {

            console.log(error)


        })




    },












    //------------------------------------------------------------------
    //takes a list of media items ( images / videos ) from firestore
    //and adds them to vue to be rendered
    buildupMediaItems: function(mediaItems, prepend) {

        const numberOfImages = mediaItems.length
        var imageCount = 1

        console.log(numberOfImages + " images")

        store.tempApprovedImages = []
        store.tempNotApprovedImages = []

        //if for whatever reason, we don't have anything
        //simply show the user the page
        if (!mediaItems.length) {

            console.log('Gonna show page')

            //if the user is on a regular page, lets show them the empty state
            //if they are on a live page, let them force this by clicking start slideshow
            if ( store.live ) {

                console.log(store.showEntirePage)
                console.log('gonas setup live page')
                store.setupLivePage


            } else {



            store.showEntirePage = true

            }

        }

        console.log('@@@@@@@@@@')
        console.log(store.showEntirePage)

        //loop through each of the media items
        mediaItems.forEach(async function(itemRef, index) {

            console.log('Storage object:')
            console.log(itemRef)
            console.log(itemRef.fileAttributes.m)


            //transform content type if quicktime to mp4
            var metadataString = itemRef.fileAttributes.m === 'video/quicktime' ? 'video/mp4' : itemRef.fileAttributes.m

            //if this image is approved then lets add it to this event.
            //we still loop through the other items
            if (itemRef.fileAttributes.a === true) {

                var payload = {
                    'imageCaption': itemRef.fileAttributes.c,
                    'imageDate': itemRef.fileAttributes.t,
                    'imageDeleting': false,
                    'imageName': itemRef.filename,
                    'imageApproved': itemRef.fileAttributes.a,
                    'mediaType': metadataString,
                    'width': itemRef.fileAttributes.w,
                    'height': itemRef.fileAttributes.h,
                    'duration': itemRef.fileAttributes.d,
                    'email': itemRef.fileAttributes.e,
                    'color' : itemRef.fileAttributes.l,
                    'font' : itemRef.fileAttributes.f,
                    'rot' : itemRef.fileAttributes.rot
                }

                console.log('Approved Image: ')
                console.log(payload)
                store.tempApprovedImages.push(payload)


            } else {


                var payload = {
                    'imageCaption': itemRef.fileAttributes.c,
                    'imageDate': itemRef.fileAttributes.t,
                    'imageDeleting': false,
                    'imageName': itemRef.filename,
                    'imageApproved': itemRef.fileAttributes.a,
                    'mediaType': metadataString,
                    'width': itemRef.fileAttributes.w,
                    'height': itemRef.fileAttributes.h,
                    'duration': itemRef.fileAttributes.d,
                    'email': itemRef.fileAttributes.e,
                    'color' : itemRef.fileAttributes.l,
                    'font' : itemRef.fileAttributes.f
                }

                console.log('Not Approved Image: ')
                console.log(payload)
                store.tempNotApprovedImages.push(payload)


            }


            //if this is the last image
            if (numberOfImages === imageCount) {

                console.log('REACHED LAST IMAGE')
                

                //make sure it is sorted by most recent first
                store.tempApprovedImages.sort((a, b) => (a.imageDate < b.imageDate) ? 1 : -1)
                store.tempNotApprovedImages.sort((a, b) => (a.imageDate < b.imageDate) ? 1 : -1)

                

                //--------------------------------------------------------------------------------------------
                //loop through each of the approved images
                //--------------------------------------------------------------------------------------------
                for (var imageCounter = 0; imageCounter < store.tempApprovedImages.length; imageCounter++) {

                    
                    //see if we can find this image......
                    var foundApprovedIndex = store.approvedImages.findIndex(image => image.imageName == store.tempApprovedImages[imageCounter].imageName);

                    //if we can't find this image, we know it is new
                    if (foundApprovedIndex === -1) {

                        //if this is the live page, and we are just loading images, just push them in as normal
                        if ( store.live && store.pauseLive == false  ) {

                            console.log('in live.....')
                            store.approvedImages.push(store.tempApprovedImages[imageCounter]);


                        //but if this is the live page and we received this via and update, we splice the image so it shows up
                        //soon after someone uploaded
                        } else if ( store.live && store.pauseLive == true) {
                           

                                        console.log('!!!! splicing in at ' + store.mediaIndex)

                                        var lengthOfArray = store.approvedImages
                                        var potentialPosition = store.mediaIndex + 2

                                        potentialPosition = potentialPosition > lengthOfArray - 1 ? 0 : potentialPosition

                                        store.approvedImages.splice(potentialPosition, 0, store.tempApprovedImages[imageCounter]);
                                        store.pauseLive = false
                         


                        } else {

                        //and if this came from a live update, we prepend it so the user sees it at the top of the list
                        if (prepend === true) {

                            console.log('Prepend = true')

                            store.approvedImages.unshift(store.tempApprovedImages[imageCounter])


                        //if this came via an infinite scroll, then add to the bottom
                        } else {

                            console.log('Prepend = false')

                            store.approvedImages.push(store.tempApprovedImages[imageCounter])

                            //if the user is swiping through a gallery, we also need to append it 
                            //to that for infinite swiping
                            if (store.galleryOpened) {

                                console.log('@@@@@@@@@@ ADD!!!!')
                                store.addGalleryItem( store.gallery.items, imageCounter, store.tempApprovedImages)

                                
                            }


                        }


                        }

                    //otherwise we already have this document, which most likely came through from a approval / denial on the management page
                    } else {

                        console.log('!!! already have this !!!')

                    }


                }


                //--------------------------------------------------------------------------------------------
                //loop through each of the unapproved images
                //--------------------------------------------------------------------------------------------
                for (var imageCounter = 0; imageCounter < store.tempNotApprovedImages.length; imageCounter++) {

                    

                    var notFoundApprovedIndex = store.notApprovedImages.findIndex(image => image.imageName == store.tempNotApprovedImages[imageCounter].imageName);

                    if (notFoundApprovedIndex === -1) {

                        if (prepend === true) {

                            store.notApprovedImages.unshift(store.tempNotApprovedImages[imageCounter])


                        } else {

                            store.notApprovedImages.push(store.tempNotApprovedImages[imageCounter])

                        }

                    } else {

                        console.log('!!! already have this !!!')

                    }




                }



               console.log('made it to next tick')

                //when we know vue has rendered
                store.vue.$nextTick(() => {

                    //setup lazy loading
                    yall({

                        observeChanges: true,
                        callback: "log"

                    });



                //on the first time we render thi 
                if ( store.showEntirePage === false ) {

                    console.log('need to show whole page')
                    //wait a split second and then show the page
                    setTimeout(function() {

                        if ( store.live ) { 
                            
                            console.log('gonna setup live page')
                            store.setupLivePage() 
                        
                        }

                        else {

                        //store.layMasonry()
                        store.showEntirePage = true

                        }

                    }, 500);

                }


                })


            }


            //increment the image counter. so we know when we are done
            //and can render
            imageCount++;


            
        });




    },





    //this helps with the sizing of the image / videos to maximize it on a live page.
    //I couldn't find a way to do this in pure css so decided to calculate and set heights
    //so we could maximize image / video heights fluidly based on screen size.  
    setupLivePage : function() {


        store.windowHeight = $(window).outerHeight();
        store.windowWidth =  $(window).width();

        if ( store.windowHeight > store.windowWidth) {

            store.portraitOrientation = true


        } else {

            store.portraitOrientation = false


        }



        store.eventNavigationHeight = $('#eventNavigation').outerHeight();

        console.log( 'Event Navigation Height: ' + store.eventNavigationHeight )

        store.eventBackgroundHeight = $('#eventBackground').outerHeight();
        store.eventCodeHeight = $('#eventCode').outerHeight();

        console.log( 'Event Background Height: ' + store.eventBackgroundHeight)

        console.log(store.windowHeight)
        console.log(store.windowWidth)
        console.log(store.eventBackgroundHeight)

        store.leftoverHeight =  store.windowHeight - store.eventBackgroundHeight - store.eventNavigationHeight -  store.eventCodeHeight

        $('#mediaContainer').height( store.leftoverHeight - 40)
        $('#slideshow').height( store.leftoverHeight - 20)
        $('.imageContainer').height( store.leftoverHeight - 20)



       







    },




    //-------------------------------------------------
    //show all the good stuff on the event page
    //-------------------------------------------------
    buildupEventPage: function(payload) {

        //yes, a hack, but the easiest way to accept any
        //url for promotion and then make it look personanlized
        //without having an actual picpack behind it
        if ( payload.eventName === 'fake-picpack-kaizen' ) {

            //pop off the last part of the name that tells us the 
            //style of picpack we will show the prospect
            var eventName = store.vue.eventID.split('-')
            eventName.pop()
            eventName.join('-')

            store.eventName =  eventName.join('-')


        } else {

            store.eventName = payload.eventName

        }
        //-------------------------------------------------------

       
        store.requireApproval = payload.requireApproval
        store.backgroundColor = payload.backgroundColor
        store.eventImageURL = payload.eventImageURL
        store.requirePassword = payload.requirePassword
        store.requireCaption = payload.requireCaption
        store.requireEmail = payload.requireEmail
        store.secretFolder = payload.secretFolder
        store.locked = payload.locked
        store.fontName = payload.fontName
        store.eventCode = payload.eventCode
        store.eventDescription = payload.eventDescription
        store.giftDenominationDisplay = payload.giftDenomination
        store.processingFeeDisplay = payload.processingFee
        

        //set the styling for this event
        store.setEventStyling(payload)

        if ( store.eventDetailsLoaded === false) {


            store.setUploadSnapshot()
            store.eventDetailsLoaded = true

        }

       

       



    },


    goToEvents : function() {

        window.location = "/picpacks"


    },





    lockFromEvents : function(event) {

        console.log(event.eventID)
        store.vue.eventID = event.eventID
        store.locked = event.locked

        event.locked = event.locked ? false : true
        store.lockEvent(event)

    },



    //-------------------------------------------------
    //lock / unlock event, e.g. hide upload buttons
    //-------------------------------------------------
    lockEvent : function(event) {

        store.toggleDropdown()

        if ( event.target ) {

            event.preventDefault()
            event.stopPropagation()

        }
       

        console.log(store.locked)
        console.log(store.vue.eventID)

        var lockVal = store.locked ? false : true

        var userDoc = store.firestore.collection('events').doc(store.vue.eventID);
        userDoc.set({

            locked : lockVal,
            
            

        }, {
            merge: true
        }).then(doc => {


            store.locked = lockVal
            store.vue.$forceUpdate();

        }).catch(error => {

            console.log(error)


        })



    },








    //-------------------------------------------------
    //toggle the dropdown in the manage screen
    //-------------------------------------------------
    toggleDropdown: function() {

        store.dropdownOn = store.dropdownOn ? false : true

        console.log( store.dropdownOn)
        store.vue.$forceUpdate();



    },


    //-------------------------------------------------
    //toggle the dropdown in the manage screen
    //-------------------------------------------------
    hideDropdown: function() {

        //event.preventDefault()
        //event.stopPropagation()

        store.dropdownOn = false 
        store.vue.$forceUpdate();
       



    },





    //-------------------------------------------------
    //open a new tab with the event flyer which has the 
    //quick code and qr code for printing and taping on wall for example
    loadFlyer: function(event) {

        event.preventDefault()
        event.stopPropagation()
        store.toggleDropdown()

        var win = window.open('/flyer/' + store.vue.eventID, '_blank');

    },




    addGalleryItem : function(items,imageCount,imageArray) {

        console.log(items)
        console.log(imageCount)


        //grab the media type
        var mediaType = imageArray[imageCount].mediaType

        var title = '<div class="mb-2 text-center"><a onclick="event.stopPropagation();" class="cursor-pointer bg-black border-yellow-300 p-1 rounded-lg border text-lg text-yellow-300" target="_blank" href="' + store.storageBucketRootURL + store.secretFolder + "/" +  encodeURIComponent(imageArray[imageCount].imageName) + '">Download</a></div>'

        //if this is an image......
        if (mediaType === 'image/png' || mediaType === 'image/jpg' || mediaType === 'image/jpeg' || mediaType === 'image/gif') {

            //build out the photoswipe image object


            //for some off reason, sometimes the cloud function returnes an image
            //without a width or height and we need to catch this.  the image
            //will be mangles but at least something will appear
            var widthOfMediaItem
            var heightOfMediaItem

            if ( typeof imageArray[imageCount].width === 'undefined') {

                widthOfMediaItem = 500

            } else {

                widthOfMediaItem = imageArray[imageCount].width
            }

            if ( typeof imageArray[imageCount].height === 'undefined') {

                heightOfMediaItem = 500

            } else {

                heightOfMediaItem = imageArray[imageCount].height
            }


            var src

            if ( mediaType === 'image/gif' ) {

                src = store.storageBucketRootURL + store.secretFolder + "/" + encodeURIComponent(imageArray[imageCount].imageName)


            } else {

                if ( store.giftDenominationDisplay === 0 ) {

                    src = store.storageBucketRootURL + store.secretFolder + "/thumbs/" + encodeURIComponent(imageArray[imageCount].imageName)


                } else {

                    src = store.storageBucketRootURL + store.secretFolder + "/" + encodeURIComponent(imageArray[imageCount].imageName)


                }

               


            }
           
            

            items.push({
                'src': src,
                'w': widthOfMediaItem,
                'h': heightOfMediaItem,
                'title' : title,
                //'caption' : title,
            })
            

          


        //if this is a video, lets do some custom html.  this is where we should be
        //able to do a custom video.js
        } else {

            

            
            
            //here is our video html
            items.push({
                'html': '<div class="h-full  pb-10 my-auto mx-auto"><video poster="' + store.storageBucketRootURL + store.secretFolder + "/thumbs/" + encodeURIComponent(imageArray[imageCount].imageName.split('.').slice(0, -1).join('.') + ".png") + '" class="video max-h-full w-full" controls playsinline style="position: relative; top: 50%; transform: translateY(-50%);" preload="auto"><source src="' + store.storageBucketRootURL + store.secretFolder + "/" + encodeURIComponent(imageArray[imageCount].imageName) + '" type="video/mp4"></video></div>',
                'title' : title,

            })
            


        }


       if ( store.gallery ) {

        console.log('updating it!!!!!')
       // store.gallery.ui.update()
        //store.gallery.invalidateCurrItems();

       }



    },





    nextSlide : function(slideNo, dir) {
       
    },




    slideLoop : function() {

        store.showEntirePage = true
        store.slideShowStarted = true


        var duration = 10000

        var image = $('#liveImage')


        store.numberOfMedia = store.approvedImages.length
        store.mediaIndex =  store.mediaIndex + 1  >= store.numberOfMedia ? 0 : store.mediaIndex + 1 

        var imageHeight = store.approvedImages[store.mediaIndex].height
        var imageWidth = store.approvedImages[store.mediaIndex].width

        console.log("Width : " + imageWidth + " - Height: " + imageHeight)

        var imagePortraitOrientation = parseInt(imageHeight) > parseInt(imageWidth) ? true : false

        console.log('Portrait: ' + imagePortraitOrientation)

        store.mediaItem = store.approvedImages
        console.log('Media Index' + store.mediaIndex)



        if ( store.portraitOrientation && imagePortraitOrientation ) { 

            console.log('Portrait Screen : Portrait Image')
            //image.css('height',store.leftoverHeight - 20)

        }

        if ( store.portraitOrientation && !imagePortraitOrientation  ) { 

            console.log('Portrait Screen : Landscape Image')
            //image.css('width', store.windowWidth)

        }

        
        if ( !store.portraitOrientation && imagePortraitOrientation ) { 

            console.log('Landscape Screen : Portrait Image')
            //image.css('height',store.leftoverHeight - 20)

        }

        if ( !store.portraitOrientation && !imagePortraitOrientation  ) { 

            console.log('Landscape Screen : Landscape Image')
            //image.css('width', store.windowWidth)

        }



       
        

        if (  store.approvedImages[store.mediaIndex].mediaType === "image/jpeg" ||  store.approvedImages[store.mediaIndex].mediaType === "image/png") {

           

          
           // image.addClass('fade-in')

            //console.log('this is a image')


        } else 

        {

           
            //console.log(video)
            duration = parseFloat(store.approvedImages[store.mediaIndex].duration) * 1000
            console.log('Duration: ' + duration)

            //setTimeout(function(){

                var checkExist = setInterval(function() {

                    if ($('#liveVideo').is(":visible")) {
        
                        var video = document.getElementById("liveVideo");
                        video.play()
                        clearInterval(checkExist);
        
                    }
        
                }, 50); // check every 100ms

        

        } 
       
       

        
        
        window.setTimeout(store.slideLoop, duration);

    },





    slideShow : function(id) {

        //store.delay = 1000
        //store.showEntirePage = true
        //store.mediaIndex = -1

        //store.slideLoop()

        /*

        store.showEntirePage = true

        var audio = document.getElementById("audio");
        audio.play();

        store.mediaIndex = 0

        if ( store.slideShowStarted === false ) {

        setInterval(function(){ 

            store.slideShowStarted = true


            //if we just received some new images, lets wait until
            //we have it all setup ok
            if ( store.pauseLive === false ) {

                store.numberOfMedia = $('#slideshow li').length

                var video = document.getElementById("video-" + store.mediaIndex);

                console.log(video)

                //if ( video.length ) {

                    console.log('here')
                    video.play()

                //}

                console.log('Current Image Index: ' + store.mediaIndex)
                console.log('Number of images: ' + store.numberOfMedia)

                //if ( store.previousMedia ) { store.previousMedia.addClass('hidden') }

                //console.log('remove')
                //$('#live-' +  store.mediaIndex).removeClass('fade-in')
                //$('#live-' +  store.mediaIndex).addClass('fade-out')

                //setTimeout(function() {

                    store.mediaIndex =  store.mediaIndex + 1  >= store.numberOfMedia ? 0 : store.mediaIndex + 1 
                    //store.vue.$forceUpdate();
                    //if ( store.mediaIndex  >= store.numberOfMedia ) { store.mediaIndex = 0 }


                //}, 2000);

                


            }


         }, 4000);

        }


        */
       
    },





    //-------------------------------------------------
    //show the photo gallery
    //-------------------------------------------------
    showGallery: function(event,el) {

        if ( store.website === "a" ) {
        

        //prevent any further clicks
        event.preventDefault()
        event.stopPropagation()


       

        


       
        //not sure if this helps or not but we trigger a sound
        //in the event we want sound on autoplay
        var audio = document.getElementById("audio");
        audio.play();


        //grab the photoswipe element
        var pswpElement = document.querySelectorAll('.pswp')[0];
        var items = []

        //loop through each of the images that are currently showing on the page
        for (var imageCount = 0; imageCount < store.approvedImages.length; imageCount++) {


            store.addGalleryItem(items,imageCount,store.approvedImages)

            
            

        }


       

        // define options (if needed)
        var options = {
            captionEl: true,
            index: el, // start at first slide
            fullscreenEl: true, //dont full screen
            shareEl: false, //don't have any share / download
            history: false, //no reason for appenending the url
            counterEl: false, //don't show counrer as its misleading on infinite scroll
            loop: false, //don't loop so the user knows they are at the end
            tapToToggleControls: false,
            arrowEl: false,
        };


        // Initializes and opens PhotoSwipe
        store.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        store.gallery.init();


       

        //lets us know the galler is opened so we can append to it
        //one infinite swipe if we need to
        store.galleryOpened = true

        store.gallery.listen('beforeChange', function() {

            //alert('ok')

            console.log('here')
            $('.video').each(function() {
                $(this).get(0).pause();
            });

         });

        //when the user swipes
        store.gallery.listen('afterChange', function() {

            console.log('going into change')

            console.log(store.approvedImages.length)
            console.log(this.getCurrentIndex())

            console.log('after going into change')

            //if we are getting near the end
            if ((store.approvedImages.length - this.getCurrentIndex()) < 4) {


                //if there are more documents
                if (store.moreDocs) {

                    //let's go grab some images
                    store.lookupEvent()
                }


            }

            //store.vue.gallerySrc = store.gallery.currItem.src
            //store.vue.galleryLoaded = store.gallery.currItem.loaded
            //store.vue.galleryImageAppended = store.gallery.currItem.imageAppended


            store.vue.$forceUpdate();

        });


        //if the user closed the galler, toggle the flag
        //so we don't try to update it on infinite scroll
        store.gallery.listen('destroy', function() {

            console.log('closing gallery')
            store.galleryOpened = false

            console.log('here')
            $('.video').each(function() {
                $(this).get(0).pause();
            });

        });



    } 



    },






    //-------------------------------------------------
    //set the branding for this event
    //-------------------------------------------------
    setEventStyling: function() {

        //get the rgb representation of the color the user selected
        var rgbColor = hexRgb(store.backgroundColor)

        var eventBackground = document.getElementById('eventBackground')

        //set the background with the color and the image they selected
        var gradient = 'linear-gradient(to right, rgba(' + rgbColor.red + ',' + rgbColor.green + ',' + rgbColor.blue + ', 0.4),rgba(' + rgbColor.red + ',' + rgbColor.green + ',' + rgbColor.blue + ', 0.4))';
        var backgroundString = gradient + ' repeat, url("' + store.eventImageURL + '") repeat';
        eventBackground.style.background = backgroundString


        $('#eventDisplayName').css('background-color', 'rgba(' + rgbColor.red + ',' + rgbColor.green + ',' + rgbColor.blue + ', 1.0)')
       

    },






    //-------------------------------------------------
    //let the user move through preselected wallpapers
    //-------------------------------------------------
    rotatePhoto: function() {

        var wallpaper = []

        

        for ( var wallpaperCount = 0; wallpaperCount < store.wallpaperImages.length; wallpaperCount++ ) {

            wallpaper.push(store.assetsBucketRootURL + "assets/images/" + store.wallpaperImages[wallpaperCount])

        }
        


        if (store.photoIndex === wallpaper.length - 1) {

            store.photoIndex = 0

        } else {

            store.photoIndex++;


        }

        store.eventImageURL = wallpaper[store.photoIndex]

        console.log(store.wallpaperImages[store.photoIndex])

        store.setEventStyling()



    },







    //pins the action bar to the top of the page
    //we poll for it to be visible before making
    //it sticky.  wierdness happens if you dont
    makeActionBarSticky: function() {


        var checkExist = setInterval(function() {

            if ($('#stickyActions').is(":visible")) {

                setTimeout(function() {

                    var $sticky = $('#stickyActions');
                    $sticky.hcSticky({
                        stickTo: 'main',
                    });

                    console.log("Got Sticky Bar");

                }, 500);
                clearInterval(checkExist);


            }

        }, 100); // check every 100ms



    },




    //-----------------------------------------------------
    //poll for new media that may have been uploaded
    setUploadSnapshot: function() {

        if ( store.website === "a") {

        console.log('++++ Setting snapshot for event page ++++')


        //a initial snapshot is always taken
        //in this case we flag so we can ignore when 
        //it fires the first time
        store.initialSnapshot = true

        //if this event doesn't require approval, or we are on a event page and not the manage page,
        //we only want to poll for approved documents
        if (store.requireApproval === false || store.requireApproval === true && store.manageEvent === false) {


            console.log('++++ Setting snapshot for event page ++++')
            console.log(store.vue.eventID)

            if ( store.live ) {


            
            //look for approved documents.
            store.firestore.collection("events").doc(store.vue.eventID).collection('media').where("a", "==", true).orderBy("t", "desc").limit(1).onSnapshot(function(snapshot) {

                console.log('SNAPSHOT FIRED')

                //if this is the first time around, ignore it
                if (store.initialSnapshot) {

                    store.initialSnapshot = false;

                //if this is the second time around, someone just uploaded a media
                } else {


                    //lets wait a 5 seconds to make sure google storage honors the URL for the media
                    var timeToWait = store.live ? 10000 : 10000
                    setTimeout(function() {

                        //for each of the snapshot changes
                        snapshot.docChanges().forEach(function(change) {


                            //if a document was added lets add it to the counter
                            //so the bell shows up for the user and we add it to
                            //our new media array
                            if (change.type === 'added') {

                                store.pauseLive = true

                                //lets see if this updated document appears in either the approved or not approved arrays
                                var foundNotApprovedIndex = store.notApprovedImages.findIndex(image => image.imageName == change.doc.id);
                                var foundApprovedIndex = store.approvedImages.findIndex(image => image.imageName == change.doc.id);

                                //if it doesn't appear, we know this is an uploaded document and not a approval / denial
                                //so we can show the bell to the user
                                if (foundNotApprovedIndex === -1 && foundApprovedIndex === -1) {

                                    console.log('Found this new doc!!!')
                                    console.log(change.doc.id)


                                    var foundUpload = store.uploadedImageArray.filter(function (upload) {
                                        return upload.name === change.doc.id;
                                      });

                                      console.log('Upload array length')
                                      console.log(foundUpload.length)

                                    if ( foundUpload.length === 0 ) {

                                        store.newImageCount++;
                                        store.freshMediaCollectionArray.push({
                                            'filename': change.doc.id,
                                            'fileAttributes': change.doc.data()
                                        })

                                    }


                                }


                            }

                        })


                        //if we are on the live page, we can just go ahead and refresh the images right away......
                        if ( store.live ) {     store.buildupMediaItems(store.freshMediaCollectionArray, true)       }

                    }, timeToWait);

                }




            })  

        }

        } else {


            //we only need to listen when requiring approval on the management page.
            //users should know when stuff is uploaded that they can't see.
            if (store.manageEvent) {


                /*
                store.firestore.collection("events").doc(store.vue.eventID).collection('media').where("a", "==", false).orderBy("t", "desc").limit(1).onSnapshot(function(snapshot) {


                    console.log('++++ Setting snapshot for require approval management page ++++')

                    if (store.initialSnapshot) {

                        store.initialSnapshot = false;

                    } else {

                        setTimeout(function() {

                            snapshot.docChanges().forEach(function(change) {

                                console.log(change.type)

                                if (change.type === 'added') {

                                    console.log(change.doc.id)


                                    //lets see if this updated document appears in either the approved or not approved arrays
                                    var foundNotApprovedIndex = store.notApprovedImages.findIndex(image => image.imageName == change.doc.id);
                                    var foundApprovedIndex = store.approvedImages.findIndex(image => image.imageName == change.doc.id);

                                    //if it doesn't appear, we know this is an uploaded document and not a approval / denial
                                    //so we can show the bell to the user
                                    if (foundNotApprovedIndex === -1 && foundApprovedIndex === -1) {

                                        store.newImageCount++;
                                        store.freshMediaCollectionArray.push({
                                            'filename': change.doc.id,
                                            'fileAttributes': change.doc.data()
                                        })

                                    } else {

                                        console.log('Ignore this snapshop')


                                    }


                                }



                            })

                        }, 5000);

                    }



                })  */


            }


        }


    }



    },




    layMasonry: function() {

        

       console.log("Laying masonry")

        


        store.masonry = $('.grid').masonry({
            itemSelector: '.grid-item',
            percentPosition: true,
            columnWidth: '.grid-sizer'
            });


            store.masonry.on( 'layoutComplete', function( event, items ) {
                console.log( 'all done' );
              });

        
            // layout Masonry after each image loads
            //store.masonry.imagesLoaded().progress( function() {
            store.masonry.imagesLoaded( function() {

                console.log('images are loaded')
            store.masonry.masonry();
            }); 

        store.logMessage = "Done Laying masonry"

            


    },



    initiateStripe: async function() {


        //UPDATE WHEN GOING TO PROD!!!!!!!
        if (location.hostname === 'localhost' || location.hostname === '192.168.0.22') {


            store.localhost = true

            if ( store.website === "a") {

            store.stripe = await loadStripe('pk_test_51IC9PgFE54E661IRhdrLHme9qP8XmNHSdCPuAsCzETDb9oqHRN2RiF6Ky5amvDT2Lgad410izyQk3ybJ7kwFFxAf00bE0e9yvP');

            } else {

            store.stripe = await loadStripe('pk_test_51IdQAfIePVvWGTZUwsR1lrkKLRL7Fsexr2z8rZkvBc89cmfve0wMiOD7By7JL53AQBaDthvjcgrzIJO3XLkq7WCb00qesO00U7');

            }

        } else {



            store.localhost = false

            if ( store.website === "a") {

                store.stripe = await loadStripe('pk_live_51IC9PgFE54E661IR95TZLbl6tEsO4wXmSoyYpC1utYB1ly6Q9Lqyv3Y1vZykkuIl4UCfSrUiR8v30uhQ9YyFHff200wcSQiGZm')

            } else {

                store.stripe = await loadStripe('pk_live_51IdQAfIePVvWGTZUv6KkjzzPnBvPI0N8PItpDdXftrg1g8fkzgo0SFx50Xep0ynhMdu8P5H0MoIwumh1LS3uD7gL00CArkJHtf')

            }


        }



        var elements = store.stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        var style = {
            base: {
                // Add your base input styles here. For example:
                fontSize: '18px',
                color: "#000000",
                lineHeight: '1.8',
                "::placeholder": {
                    color: "#A9A9A9"
                }

            }
        };

        // Create an instance of the card Element.
        store.card = elements.create('card', {
            style: style
        });

        // Add an instance of the card Element into the `card-element` <div>.
        store.card.mount('#card-element');


        store.card.addEventListener('change', function(event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });




    },
    //--------------------------------------------------------------------------
    //--------------------------------------------------------------------------



    fallbackCopyTextToClipboard: function(text) {



        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    },


    highlightFor: function(id, color, seconds) {

        console.log(id)
        var element = $(id)[0]
        var origcolor = element.style.backgroundColor
        element.style.backgroundColor = color;
        var t = setTimeout(function() {
            element.style.backgroundColor = origcolor;
        }, (seconds * 1000));
    },


    copyTextToClipboard: function(textToCopy, typeOfEvent,eventID,eventIndex,recipientName,giftLink,teamName) {

        console.log(typeOfEvent)

        var tempInput = document.createElement("textarea");
        tempInput.style = "position: absolute; left: -1000px; top: -1000px";

        var elementID;

        if ( typeOfEvent === 'eventID' ) {


            if ( store.website === "a") {

                tempInput.value = 'https://picpack.app/' + textToCopy;
                elementID = "link-" + eventID

            } else {

                tempInput.value = 'https://giftycard.app/' + textToCopy;
                elementID = "link-" + eventID


            }

           
        } else if ( typeOfEvent === 'giftLink' ) {

            console.log('@@@@@@@@@@@@@@@')
            console.log(textToCopy)

            tempInput.value = "Hi " + recipientName + ",\r\n\r\n" + teamName + " really appreciates you!\r\n\r\nClick both links below for a surprise:\r\n\r\nhttps://giftycard.app/" + textToCopy + "\r\n\r\n" + giftLink;
            elementID = "gift-" + eventID



        } else {


            if ( store.website === "a") {

            tempInput.value = 'Go to https://picpack.app and enter Secret Code: ' + textToCopy;
            elementID = "invite-" + eventID

            } else {

            tempInput.value = 'Go to https://giftycard.app and enter Secret Code: ' + textToCopy;
            elementID = "invite-" + eventID



            }
           

        }


        console.log('here')
       
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        store.highlightFor('#' + elementID, "#FCD34D", .3)


        store.vue.events[eventIndex].sharing = "Copied to Clipboard"
        //store.vue.$forceUpdate();


        /*

        
         console.log(eventID)
        var copyText = document.getElementById(eventID);

      
        copyText.select();
        copyText.setSelectionRange(0, 99999); 

       
        document.execCommand("copy");

        

        console.log(eventID)
        store.highlightFor('#' + eventID + " ." + objectClass, "#FCD34D", .2)


        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function() {
            console.log('Async: Copying to clipboard was successful!');
        }, function(err) {
            console.error('Async: Could not copy text: ', err);
        });

        */
    },



    generateVideoPreview : function(file) {

        return new Promise(function(resolve, reject) {

           

        
          var url = URL.createObjectURL(file);
          var video = document.createElement('video');

          video.addEventListener('loadeddata', function() {

            video.pause();
            
          });

          video.addEventListener("pause", function() {
              
            snapImage()
            
          });

          var snapImage = function() {

            try {
  
                var canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
                var image = canvas.toDataURL();
         
                resolve(image)


        } catch(err) {

            store.logMessage = err
            reject('fail')

        }
            
    };

         
          video.preload = 'metadata';
          video.src = url;
          video.muted = true;
          video.playsInline = true;
          store.logMessage = "about to play video"
          video.play();
         





















        })

    },




    getVideoDetails: function(videoFile, _callback) {


        console.log('get video details')

        const onChangeFile = (mediainfo) => {
            const file = videoFile
            if (file) {
                //output.value = 'Working…'
                console.log('here')

                const getSize = () => file.size

                console.log('here 2')

                const readChunk = (chunkSize, offset) =>
                    new Promise((resolve, reject) => {
                        const reader = new FileReader()
                        reader.onload = (event) => {
                            if (event.target.error) {

                                reject(event.target.error)

                            } else {

                               

                                resolve(new Uint8Array(event.target.result))

                            }
                        }
                        reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize))
                    })

                mediainfo
                    .analyzeData(getSize, readChunk)
                    .then((result) => {
                        //output.value = result

                       

                        var videoDetails = JSON.parse(result);

                        console.log('+++++++++++++++++++++++++++++++')
                        console.log(videoDetails)

                        //not sure why it doesn't it like this but rotation determines
                        //the true height and width
                        var width;
                        var height;

                        if ( videoDetails.media.track[1].Rotation === "0.000" ) {

                            width = videoDetails.media.track[1].Width
                            height = videoDetails.media.track[1].Height


                        } else {

                            width = videoDetails.media.track[1].Height
                            height = videoDetails.media.track[1].Width



                        }


                        if (videoDetails.media.track[1].Format === 'HEVC') {

                            _callback(false, videoFile.name, videoFile, width, height)


                        } else {

                            _callback(true, videoFile.name, videoFile, width, height)


                        }
                        //console.log(videoDetails.media.track[1].Format)


                    })
                    .catch((error) => {

                        _callback(false, videoFile.name, videoFile)
                        //output.value = `An error occured:\n${error.stack}`
                    })
            }
        }


        MediaInfo({
            format: 'JSON'
        }, (mediainfo) => {
            onChangeFile(mediainfo)
        })



    },




    isVideoUnderMaxDuration: function(file, width, height, _callback) {

        // var vue = this

        var video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = function() {

            window.URL.revokeObjectURL(video.src);


            if (video.duration < store.maxVideoDuration) {

                console.log('got a good one')
                //return true
                _callback(true, file.name, file, width, height,video.duration)


            } else {

                console.log('got a bad one')
                //return false
                _callback(false, file.name, file, width, height,video.duration)

            }

            //return video.duration

        }

        video.src = URL.createObjectURL(file);;

    },




    uploadFiles: function(upload) {


        if ( store.website === "b") {


        store.addMessage = false
        store.addGift = false
        store.addGif = false
        store.purchased = false
        store.showMedia = true



        }


        store.generateRandomSuccessMessage()

        //var vue = this

        window.scrollTo(0, 0);

        store.uploadedFileCount = 0
        store.uploadedImageArray = []
        store.videoUploaded = false
        //store.finalUploadedFiles = []



        console.log('upload files')
        var files = upload.target.files;

        store.uploadedFiles = []

        for (var fileCount = 0; fileCount < files.length; fileCount++) {

            store.uploadedFiles.push({
                "fileName": files[fileCount].name,
                "fileGood": true,
                "fileBadReason": ""
            })


        }




        var fileArray = []

        var mimeTypeArray = ['image/jpeg', 'image/png', 'image/gif','video/mp4', 'video/quicktime']
        var videoTypeArray = ['video/mp4', 'video/quicktime']

        store.vue.processedFilesCount = 0
        store.uploadFileCount = files.length

        //for ( var fileCount = 0; fileCount < files.length; fileCount++) {
        Array.from(files).forEach(function(userFile, i) {

            // console.log(files[fileCount].name)
            //console.log( files[fileCount].type) 

            //if ( mimeTypeArray.includes(files[fileCount].type) ) {
            if (mimeTypeArray.includes(userFile.type)) {

                //console.log(files[i].type)
                console.log(userFile.type)


                //if this is a video.....
                //if ( videoTypeArray.includes(files[fileCount].type) ) {
                if (videoTypeArray.includes(userFile.type)) {

                    console.log('gonna jump in')
                    //vue.getVideoDetails(files[fileCount],function(isVideoCompatible,videoFileName,videoFile) {
                    store.getVideoDetails(userFile, function(isVideoCompatible, videoFileName, videoFile, width, height) {


                        console.log('Is Video Compatible: ' + isVideoCompatible)
                        console.log('Video Name: ' + videoFile.name)

                        //if this is not a high efficiency video that we cant render then
                        if (isVideoCompatible) {

                            //determine if this is under the max duration
                            store.isVideoUnderMaxDuration(videoFile, width, height, async function(isVideoGood, videoFileName, videoFile, width, height,videoDuration) {

                                if (isVideoGood) {



                                    store.uploadFileToGoogleCloud(videoFileName, videoFile, userFile.type, width, height,videoDuration)

                                    //vue.uploadedFiles.push(videoFileName)

                                } else {


                                    store.vue.processedFilesCount++;


                                    var foundIndex = store.uploadedFiles.findIndex(image => image.fileName == videoFile.name);
                                    store.uploadedFiles[foundIndex].fileGood = false
                                    store.uploadedFiles[foundIndex].fileBadReason = "Videos should be under 1 minute long"


                                    // store.uploadedFiles.push({
                                    // "fileName": videoFile.name,
                                    //"fileGood": false,
                                    // "fileBadReason": "Videos should be under 1 minute long"
                                    // })

                                }

                            })


                        } else {


                            store.vue.processedFilesCount++;

                            var foundIndex = store.uploadedFiles.findIndex(image => image.fileName == videoFile.name);
                            store.uploadedFiles[foundIndex].fileGood = false
                            store.uploadedFiles[foundIndex].fileBadReason = "Browsers do not support HECV videos"


                        }




                    })




                    //if this is an image
                } else {

                    var _URL = window.URL || window.webkitURL;
                    var objectUrl = _URL.createObjectURL(userFile);
                    var file, img;


                    img = new Image();
                    img.onload = function() {
                        //alert(this.width + " " + this.height);
                        store.uploadFileToGoogleCloud(userFile.name, userFile, userFile.type, this.width, this.height,0,objectUrl)
                        //_URL.revokeObjectURL(objectUrl);
                    };

                    //store.uploadedImageArray.push({'src':objectUrl,'name':''})

                    console.log('!!!!!!!!!!!!!!!')
                    console.log(objectUrl)
                    console.log('!!!!!!!!!!!!!!!')

                    img.src = objectUrl;




                }



            }




        })




    },




    generateZIP: async function() {

        var vue = this

        store.downloadDetails = 'Grabbing Files...  Please be patient.'

        //store.hideDropdown()

        console.log('TEST');
        var zip = new JSZip();
        var count = 0;
        var zipFilename = "Pictures.zip";

        var mediaRepository;

        console.log(store.vue.eventID)

        var approved

        if ( store.vue.displayFilter === 'approved' ) { 

            approved = true

        } else {

            approved = false


        }


        var payload = {

            eventID: store.vue.eventID,
            approved: approved,
            secretFolder : store.secretFolder

        }




        var files = await axios.post(store.functionEndpoint + "getFilesFromPicPack", payload)
        
        //console.log(files.data.length)

        var numberOfFiles = files.data.length


        /*
       
        var mediaSnapshot = await store.firestore.collection("events").doc(store.vue.eventID).collection('media').where("a", "==", approved).orderBy("t", "desc").get()
        //var mediaSnapshot = await eventDoc.ref.collection('media').where("a", "==", approved).orderBy("t", "desc").get()


        console.log('@@@@@@@@@@@@@@@@@@@@@')
        console.log(mediaSnapshot)


        //console.log(mediaSnapshot)

        //console.log(eventDoc.data())

        var mediaRepository = []

        //mediaSnapshot = await eventDoc.ref.collection('media').where("a", "==", approved).orderBy("t", "desc").get()

        mediaSnapshot.forEach(function(doc) {

            console.log(doc.id)
            mediaRepository.push({'imageName':doc.id})


        })

        

        store.imageArray = mediaRepository.map(function(image) {
            return store.storageBucketRootURL + store.secretFolder + "/" + encodeURIComponent(image.imageName)
        });

        console.log(store.imageArray)

        */

        var imageCount

        var progressBar = document.getElementById('zipProgress')

        var zip = new JSZip();
        var count = 0;
        var zipFilename = "Pictures.zip";

        files.data.forEach(function(url, i) {

            //var segment_str = store.imageArray[i];; // return segment1/segment2/segment3/segment4
            //var segment_array = segment_str.split('/');
            //var filename = segment_array.pop();
            
            //console.log(url)
            var filename = url.fileName
            //console.log(filename)

            // loading a file and add it in a zip file

            JSZipUtils.getBinaryContent(url.signedURL, {
                progress: function(e) {

                    store.downloadDetails = 'Downloading File ' + count + ' of ' + files.data.length
                    //console.log(e.percent + "% loaded");

                   
                    progressBar.style.backgroundImage = "url('" + store.assetsBucketRootURL + "assets/images/blue.png')";
                    progressBar.style.backgroundSize = parseInt((count / files.data.length) * 100) + "% 100%"
                    progressBar.style.backgroundRepeat = 'no-repeat';

                   
                   
                },
                callback: function (err, data) {

                    if (err) {
                        throw err; // or handle the error
                    }

                    //console.log('###########')
                    //console.log(filename)
                    //console.log(count + " - " + numberOfFiles)

                    zip.file(filename, data, {
                        binary: true
                    });
                    count++;
                    if (count  === numberOfFiles) {

                        store.downloadDetails = "Downloading the Files.  Please be patient."
                        progressBar.style.backgroundSize = "100% 100%"
                        zip.generateAsync({
                            type: 'blob'
                        }).then(function(content) {

                            store.downloadDetails = "Downloading the Files.  Please be patient."
                            saveAs(content, zipFilename)

                            setTimeout(function(){ store.downloadDetails = "" }, 50*numberOfFiles); 
                            
                        });
                    }
                    // ...
                }
            });





            /*
            JSZipUtils.getBinaryContent(url, function(err, data) {
                if (err) {
                    throw err; // or handle the error
                }
                zip.file(filename, data, {
                    binary: true
                });
                count++;
                if (count == store.imageArray.length) {
                    zip.generateAsync({
                        type: 'blob'
                    }).then(function(content) {
                        saveAs(content, zipFilename);
                    });
                }
            });
            */


              //remove this when done testing

        });








    },



    submitGift : function() {

        store.purchasing = true
        store.statusMessage = "Creating Gift....."


        store.stripe.createToken(store.card).then(function(result) {

            console.log(result)


            if (result.error) {
                  // Inform the customer that there was an error.
                  console.log('Error With Card.....')
                   store.purchasing = false
                  var errorElement = document.getElementById('card-errors');
                  errorElement.textContent = result.error.message;
                  store.vue.signingup = false
                  store.statusMessage = ''

            } else {

                  // Send the token to your server.
                  console.log('Processing Payment.....')
                 store.statusMessage = 'Processing Gift.....'
                  store.attemptPurchase(result.token);
            }
          });






    },



    attemptPurchase : function(token) {

        var vue = this

        store.purchasing = true

        store.email = store.validateEmail(store.email) ? store.email : "bademail"

        vue.statusMessage = 'Submitting Payment.....'

        axios.post(store.functionEndpoint + 'gift', {

        authorizationType : store.authorizationType,
        //phone : store.phoneNumber,
        email: store.emailAddress,
        //plan: store.planSelectedIndex,
        //planID : store.selectedPlan,
        planAmount : store.finalGiftDenomination,
        stripeToken : token.id,
        //stripe : store.stripe,
        //stripeID : store.stripeID,
        //existingCustomer : store.existingCustomer,
        localhost : store.localhost,
        //planDescription : store.planDescription,
        //planEvents : store.planEvents,
        //planImages : store.planImages

         }).then(function (response) {

             console.log(response);
             store.statusMessage = 'Confirming Gift.....'

                    var responseFromStripe = response.data.split("~~~:::");

                    console.log(responseFromStripe)

                    if (responseFromStripe[0] === "success") {

                        
                        store.firestore.collection('events').doc(store.vue.eventID).get().then(eventDoc => {

                            store.statusMessage = 'Saving Gift.....'

                            var giftDenominationCalc

                            if ( store.customDenomination ) {

                                giftDenominationCalc = currency(store.customDenominationAmt).value


                            } else {


                                giftDenominationCalc = store.giftDenomination.value

                            }

                            const giftDenomination = firebase.firestore.FieldValue.increment(currency(giftDenominationCalc).value);
                            const processingFee = firebase.firestore.FieldValue.increment(currency(store.processingFee).value);

                            eventDoc.ref.update({ giftDenomination: giftDenomination, processingFee : processingFee }).then(update => {

                                eventDoc.ref.collection('gifts').doc().set({

                                    "giftDenomination": currency(giftDenominationCalc).value,
                                    "email": store.emailAddress,
                                    "processingFee": currency(store.processingFee).value,
                                    //"giftContribution": currency(store.giftDenomination).subtract(store.processingFee).value,
                                    "giftContribution": currency(giftDenominationCalc).value,
                                    "purchaseTime": Date.now(),
                                    "charge" : responseFromStripe[1],
                                    "customer" : responseFromStripe[2]
                                   
        
                                }).then(doc => {
        
                                    console.log('purchased logged')
                                    console.log(doc)

                                    store.statusMessage = ''
                                    store.purchasing = false
                                    store.purchased = true
                                   store.showMedia = true

                                   //window.scrollTo(0, 0);

                                    store.giftDenominationDisplay = currency(store.giftDenominationDisplay).add(giftDenominationCalc).value
                                    store.vue.$forceUpdate()

                                    confetti.start(500);

                                }).catch(error => {
        
                                    console.log('purchased error')
                                    console.log(error)
                                    store.purchasing = false
        
                                })




                            }).catch(error => {

                                console.log(error)



                            })
                            


                            
    

                        })
                        
                       


                        

                        
                    } else {
                        console.log("bad stuff happened");
                        var displayError = document.getElementById(
                            "card-errors"
                        );
                        displayError.textContent = responseFromStripe[1];
                        vue.purchasing = false
                         vue.statusMessage = ""

                        
                    }
                




         }).catch(function (error) {

              vue.purchasing = false
               vue.statusMessage = 'Something went wrong.  Please contact jason@giftycard.app'

               
             console.log(error)


    })
    
    },



    showGift : function() {

       console.log(currency(1)) // => "1.00"

        

        store.purchased = false

        store.initiateStripe()


        console.log('gonna show gift')
        store.addGift = true
        store.addMessage = false
        store.addGif = false
        store.purchased = false
        store.showMedia = false
        store.uploadedFiles = []
        store.uploadFileCount = 0

        store.giftDenomination = 0




    },


    showMessage : function() {


        //store.initiateStripe()


        console.log('gonna show message')

        store.addMessage = true
        store.addGift = false
        store.addGif = false
        store.showMedia = false
        store.purchased = false

        store.uploadedFiles = []
        store.uploadFileCount = 0



    },


    calcDenomination : function() {

        //console.log(store.giftDenomination)

        store.setDenomination(store.Denomination,true)
        //console.log(((store.giftDenomination * .029 ) + .3 + store.getProcessingFeeCharge()).toFixed(2))
        //store.processingFee = currency(store.giftDenomination).multiply(.029).add(.3).add(store.getProcessingFeeCharge())
        //store.processingFee = currency(store.giftDenomination).multiply(store.giftTip)
        //store.vue.$forceUpdate()


    },


    setDenomination : function(denomination,customDenomination) {

        if ( customDenomination ) {



          store.processingFee = currency(store.customDenominationAmt).multiply(.029).add(.3).add(store.getProcessingFeeCharge())

           store.lowTip = currency(store.customDenominationAmt).multiply(.029).add(.3).add(store.getProcessingFeeCharge())
           store.mediumTip = currency(store.customDenominationAmt).multiply(.029).add(.3).add(store.getProcessingFeeCharge()).add(.5)
           store.highTip = currency(store.customDenominationAmt).multiply(.029).add(.3).add(store.getProcessingFeeCharge()).add(1)

           if ( store.giftTip === 'highTip') {

            store.processingFee = store.highTip
            store.finalGiftDenomination = currency(store.customDenominationAmt).add(store.processingFee)
            

           }
           
           if ( store.giftTip === 'mediumTip') {

            store.processingFee = store.mediumTip
            store.finalGiftDenomination = currency(store.customDenominationAmt).add(store.processingFee)
           

           }

           if ( store.giftTip === 'lowTip') {

            store.processingFee = store.lowTip
            store.finalGiftDenomination = currency(store.customDenominationAmt).add(store.processingFee)
            

           }


        } else {

        //window.scrollTo(0,document.body.scrollHeight);

        store.customDenomination = customDenomination

        if ( store.giftDenomination === currency(denomination)) {

            store.giftDenomination = currency(0)


        } else {

            store.giftDenomination = currency(denomination)
           //store.processingFee = Math.round( (store.giftDenomination * .029 ) + .3 + store.processingFeeCharge,2)
           //store.processingFee = currency(store.giftDenomination).multiply(store.giftTip)
           store.processingFee = currency(store.giftDenomination).multiply(.029).add(.3).add(store.getProcessingFeeCharge())

           store.lowTip = currency(store.giftDenomination).multiply(.029).add(.3).add(store.getProcessingFeeCharge())
           store.mediumTip = currency(store.giftDenomination).multiply(.029).add(.3).add(store.getProcessingFeeCharge()).add(.5)
           store.highTip = currency(store.giftDenomination).multiply(.029).add(.3).add(store.getProcessingFeeCharge()).add(1)

           var currencyRounding = value => currency(value, { increment: .05 });

           if ( store.giftTip === 'highTip') {

            store.processingFee = store.highTip
            store.finalGiftDenomination = currency(store.giftDenomination).add(store.processingFee)
            

           }
           
           if ( store.giftTip === 'mediumTip') {

            store.processingFee = store.mediumTip
            store.finalGiftDenomination = currency(store.giftDenomination).add(store.processingFee)
           

           }

           if ( store.giftTip === 'lowTip') {

            store.processingFee = store.lowTip
            store.finalGiftDenomination = currency(store.giftDenomination).add(store.processingFee)
            

           }

           
       

        }


    }



    },



    setTip : function(tipAmount) {


        console.log(tipAmount)
        store.giftTip = tipAmount

        if ( store.customDenomination ) {

            store.setDenomination(store.customDenominationAmt,true)


        } else {

            store.setDenomination(store.giftDenomination,false)


        }

       




    },


    getProcessingFeeCharge : function() {


        var processingFeeCharge;

        if ( store.customDenomination ) {

            if ( currency(store.customDenominationAmt).value >= 7.50 &&  currency(store.customDenominationAmt).value <= 10 ) {

                processingFeeCharge = currency(store.customDenominationAmt).multiply(.075)


            } else if ( currency(store.customDenominationAmt).value < 7.50 && currency(store.customDenominationAmt).value < 5) {

                processingFeeCharge = currency(store.customDenominationAmt).multiply(.10)

            } else if ( currency(store.customDenominationAmt).value === 5) {

                processingFeeCharge = currency(store.customDenominationAmt).multiply(.075)


            } else {

                processingFeeCharge = currency(1)

            }



        } else {


            if ( store.giftDenomination.value >= 7.50 &&  store.giftDenomination.value <= 10 ) {

                processingFeeCharge = currency(store.giftDenomination).multiply(.075)


            } else if ( store.giftDenomination.value < 7.50 && store.giftDenomination.value < 5) {

                processingFeeCharge = currency(store.giftDenomination).multiply(.10)

            } else if ( store.giftDenomination.value === 5) {

                processingFeeCharge = currency(store.giftDenomination).multiply(.075)


            } else {

                processingFeeCharge = currency(1)

            }




        }

       

           
           

        



       // if ( store.giftDenomination === 5 ) { processingFeeCharge = 1 }
        // else if ( store.giftDenomination === 10 ) { processingFeeCharge = .75 }
        // else if ( store.giftDenomination === 20 ) { processingFeeCharge = 1 }
        //else  { processingFeeCharge = store.giftDenomination <= 20 ? 1 : 1.50 }

        // console.log(processingFeeCharge)

        console.log('!!!!!!!!!!!!!')
        console.log(processingFeeCharge)
        return processingFeeCharge.value


    },



    showCustomDenomination : function() {

        setTimeout(function() {document.getElementById("customDenomination").focus()},500)
        store.giftDenomination = 50
        //store.setDenomination(store.giftDenomination,true)
        //store.processingFee = ((store.giftDenomination * .029 ) + .3 + + store.getProcessingFeeCharge()).toFixed(2)
        store.customDenomination = true




    },




    createGif: function() {

        var vue = this;


        var imageArray = this.images.map(function(image) {
            return store.storageBucketRootURL + store.secretFolder + "/" + image
        });

        console.log('IMAGES:')
        console.log(imageArray)


        gifshot.createGIF({
            'interval': 1.25,
            'images': imageArray,
            progressCallback: function(captureProgress) {
                console.log('progress: ', captureProgress);
            },
            completeCallback: function() {
                console.log('completed!!!');
            },
        }, function(obj) {
            if (!obj.error) {

                console.log('got here')
                var image = obj.image,
                    animatedImage = document.createElement('img');
                animatedImage.src = image;
                animatedImage.classList.add("rounded-xl")
                document.getElementById('gifHolder').appendChild(animatedImage);
            } else {

                console.log('error')

            }
        });




    },


    editCaption : function(imageIndex) {

        console.log(imageIndex)

        var image = store.uploadedImageArray[imageIndex]
        image.captioned = false



    },



    submitCaption : function(imageIndex) {

        console.log(imageIndex)

        var image = store.uploadedImageArray[imageIndex]

        console.log(image)

        store.firestore.collection("events").doc(store.vue.eventID).collection('media').doc(image.name).set({

            c : document.getElementById('caption-' + image.name).value,
            
            

        }, {
            merge: true
        }).then(doc => {

            console.log('caption updated')
            image.caption = document.getElementById('caption-' + image.name).value
            image.captioned = true
            //document.getElementById('caption-' + imageID).value = "Thanks!"
            //document.getElementById('caption-' + imageID).disabled = true

            //store.locked = lockVal
           // store.vue.$forceUpdate();

        }).catch(error => {

            console.log(error)


        })


        


    },




    uploadFileToGoogleCloud: function(fileName, file, mediaType, width, height,duration,src) {

        console.log('Width and Height')
        console.log(width)
        console.log(height)

        var timeStamp = Date.now().toString()

        console.log('Sending the file here:')

        var imageName = width + '+' + height + "+" + duration + "+" + store.vue.eventID + "+" + timeStamp + "+" + fileName

        console.log('+++++++++++++++')
        console.log(src)
        console.log('+++++++++++++++')

        
       

        var storageRef = firebase.storage().ref(store.secretFolder + '/' + imageName);

        var metadata = {
            customMetadata: {
              'email': store.emailAddress,
            }
          };


        var task = storageRef.put(file,metadata);

        task.on('state_changed', function progress(snapshot) {
            var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            //uploader.value = percentage;

            console.log(file.name + " - " + percentage)

            var progressBar = document.getElementById(file.name)
            progressBar.style.backgroundImage = "url('" + store.assetsBucketRootURL + "assets/images/blue.png')";
            progressBar.style.backgroundSize = parseInt(percentage) + "% 100%"
            progressBar.style.backgroundRepeat = 'no-repeat';


            //console.log(percentage)

        }, function error(err) {

            console.log(err)


        }, async function complete() {


            store.logMessage = "completed file upload"

            var progressBar = document.getElementById(file.name)
            progressBar.style.backgroundImage = "url('" + store.assetsBucketRootURL + "assets/images/green.png')";
            progressBar.style.backgroundSize = "100% 100%"
            progressBar.style.backgroundRepeat = 'no-repeat';


            console.log('UPLOADED DOC PLEASE')

            if ( mediaType === 'video/mp4' || mediaType === 'video/quicktime') {

                store.logMessage = "found a video"

            store.videoUploaded = true

            var thumbnailImage = await store.generateVideoPreview(file)
            store.uploadedImageArray.unshift({'src':thumbnailImage,'name':imageName,'captioned':false,'caption':'','placeholder':'Add video caption'})

            } else {

                store.logMessage = "found a image"

            store.uploadedImageArray.unshift({'src':src,'name':imageName,'captioned':false,'caption':'','placeholder':'Add photo caption'})



            }


            /*
            store.finalUploadedFiles.push({
                'imageDate': Date.now(),
                "filename": timeStamp + "-" + fileName,
                "mediaType": mediaType,
                "width": width,
                "height": height
            })
            */

            



            //do this so we know when we are done
            store.uploadedFileCount++;
            store.vue.processedFilesCount++;




        })




    },




    setCookie: function(name, value, days) {

        console.log('Setting Cookie: ' + name + " : " + value)

        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        if ( store.localhost) {

            document.cookie = name + "=" + (value || "") + expires + "; Path=/";


        } else {

            if ( store.website === "a") {

                document.cookie = name + "=" + (value || "") + expires + "; Domain=.picpack.app; Path=/";


            } else {

                document.cookie = name + "=" + (value || "") + expires + "; Domain=.giftycard.app; Path=/";


            }

           


        }

       
    },



    getCookie: function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },


    eraseCookie: function(name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    },



    verifyEmail : function() {

        if ( store.validateEmail(store.emailAddress) ) {


            store.emailSet = true
            store.setCookie("email",store.emailAddress)

        } else {


            store.emailSet = false
            store.badEmail = true
           

        }


    },


    validateEmail: function(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },



    //--------------------------------------------------------------------------
    //creates a link to the new stripe customer portal
    //--------------------------------------------------------------------------
    generatePortalLink: function() {

        if ( store.website === "a" ) {

        console.log('GENERATING PORTAL LINK')

        //store.portalLoading = true

        if (typeof store.user.stripe !== 'undefined') {

            var payload = {

                stripe: store.user.stripe,
                localhost: store.localhost

            }


            try {

            axios.post(store.functionEndpoint + "customerPortal", payload)
                .then(function(response) {


                    //take the customer to their portal.  great for subscription clients

                    store.portalLink = response.data.url
                    store.portalLoading = false
                    //window.location.href = response.data.url


                }).catch(error => {
                    
                    console.log('that was bad')


                })

            } catch(error) {


                console.log('bad')

            }


        }

    }


    },
    //--------------------------------------------------------------------------
    //--------------------------------------------------------------------------



    //-------------------------------------------------------------------------------
    //logout 
    //-------------------------------------------------------------------------------
    logout: function() {


        var vue = this

        store.showEntirePage = false


        store.firebase.auth().signOut().then(function() {

            // Sign-out successful.

            window.location.href = '/'

        }).catch(function(error) {

            window.location.href = '/'


        });




    },
    //-----------------------------------------------------------------------------------




    createFirestoreUser : async function(user,authType) {

        console.log('@@@@@@@@')
        console.log(user)

        var userPayload
        var redirectCreateLink
        var redirectViewLink

        

            redirectCreateLink = "/createPicpack"
            redirectViewLink = "/picpacks"

            userPayload = {

                //name: name,
                email: user.email,
                plan: 0,
                credits: 1,
                authorizationType: authType




            }


      

        console.log('trying to fire create user with')
        console.log(userPayload)

        var name

        if ( authType === 'Google' ) {

            name = user.displayName

        } else {

            name = ""

        }

        var userDoc = await store.firestore.collection('users').doc(user.uid).get();

            if ( !userDoc.exists ) {

                userDoc = await store.firestore.collection('users').doc(user.uid)

            var userDocSet = userDoc.set(userPayload).then(doc => {


                if ( authType === 'Email' ) {

                    var actionCodeSettings = {
                        url: 'https://picpack.app'
                    }



                   




                }

                //grab the ID for this event
                const currentURL = window.location.pathname; 
                var urlSegments = currentURL.split( '/' );
                var whatToDo = urlSegments.pop();

                console.log('@@@@@@@@@@@')
                console.log(whatToDo)

                if ( whatToDo === 'login') {

                     window.location.href = redirectViewLink

                } else {

                window.location.href = redirectCreateLink

                }

            }).catch(setError => {

                console.log('we errored on creating user record')
                console.log(setError)



            })


            } else {

               //grab the ID for this event
                const currentURL = window.location.pathname; 
                var urlSegments = currentURL.split( '/' );
                var whatToDo = urlSegments.pop();

                console.log('@@@@@@@@@@@')
                console.log(whatToDo)

                if ( whatToDo === 'login') {

                     window.location.href = redirectViewLink

                } else {

                window.location.href = redirectCreateLink

                }



            }




    },




    getQueryVariable : function(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
        console.log('Query variable %s not found', variable);
    },



    //--------------------------------------------------------------------------
    //kick of a login for a user.  bascially flipps open the inline login
    //--------------------------------------------------------------------------
    checkForAuthentication: function() {

        store.localhost = location.hostname === 'localhost' ? true : false




        var vue = this;


        // Initialize Cloud Firestore through Firebase
        store.firebase = firebase;
        store.firestore = firebase.firestore();
        store.storageService = firebase.storage();


        return new Promise(function(resolve, reject) {
            firebase.auth().onAuthStateChanged(function(user) {


                if (user) {

                    store.user = user

                    user.getIdToken().then(function(token) {




                            //
                            store.authToken = token

                            //if they are authenticated and this is a new game, then create it.....
                            console.warn('APP.VUE - Logged in as: ')
                            console.log(user.email)
                            console.log(user.uid)




                            store.emailVerified = user.emailVerified;
                            store.isAuthenticated = true
                            store.userID = user.uid;
                            store.phoneNumber = user.phoneNumber
                            store.email = user.email;
                            store.emailAddress = user.email;
                            store.name = user.displayName;

                            store.logMessage = user.uid


                            let userRef = store.firestore.collection('users').doc(user.uid)
                            let userDoc = userRef.get()
                                .then(doc => {
                                    if (!doc.exists) {

                                        console.log('here')
                                        resolve(true)



                                    } else {

                                        console.log('found user!!!')


                                        store.user = doc.data()
                                        store.plan = doc.data().plan
                                        store.credits = doc.data().credits
                                        store.stripeID = doc.data().stripe
                                        store.authorizationType = doc.data().authorizationType



                                        if (store.stripeID !== undefined) {

                                            store.existingCustomer = true

                                        }

                                        //if the user has paid for something, don't make them do it again
                                        if (store.plan > 0) {

                                            store.planSelected = true

                                        }


                                        vue.pageLoaded = true
                                        //store.vue.$forceUpdate();
                                        store.authEstablished = true
                                        console.log('found user')



                                        resolve(true)




                                    }
                                })
                                .catch(err => {

                                    console.log(err)
                                    store.logMessage = err


                                });


                            //vue.pageLoaded = true


                            //store.vue.$forceUpdate();

                            //store.authEstablished = true

                            //resolve(true)




                        })
                        .catch(function(error) {

                        });




                } else {



                    console.warn('APP.VUE - Anonymous')



                    store.isAuthenticated = false
                    store.authEstablished = true
                    vue.pageLoaded = true
                    resolve(true)




                }


            })
        })


    },


    generateQuickcode: function(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }


}